import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/HubspotDealsListMcp.graphql';
import { Query, QueryhubspotDealsListMcpArgs } from '../../__generated__/globalTypes';

export const useHubspotDealsListMcpQuery = (options?: QueryHookOptions<Query, QueryhubspotDealsListMcpArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryhubspotDealsListMcpArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useHubspotDealsListMcpLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryhubspotDealsListMcpArgs>
): QueryResult<Query, QueryhubspotDealsListMcpArgs> & {
  getHubspotDealsListMcp: LazyQueryExecFunction<Query, QueryhubspotDealsListMcpArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getHubspotDealsListMcp, result] = useLazyQuery<Query, QueryhubspotDealsListMcpArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getHubspotDealsListMcp, ...result };
};

export const useHubspotDealsListMcpPromiseQuery = () => {
  const client = useApolloClient();

  const getHubspotDealsListMcp = useCallback(
    (options?: Omit<QueryOptions<QueryhubspotDealsListMcpArgs, Query>, 'query'>) =>
      client.query<Query, QueryhubspotDealsListMcpArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getHubspotDealsListMcp };
};
// Suspense Query Hooks
export const useHubspotDealsListMcpSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryhubspotDealsListMcpArgs>
) => {
  const result = useSuspenseQuery<Query, QueryhubspotDealsListMcpArgs>(QUERY, {
    ...options
  });

  return result;
};
